
import Vue from 'vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'RModal',
  components: { RButton },
  props: {
    name: {
      type: String,
    },
    clickToClose: {
      type: Boolean,
      default: true,
    },
    closingX: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: Number,
      default: 200,
    },
    minHeight: {
      type: Number,
      default: 200,
    },
    width: {
      type: [Number, String],
      default: 544,
    },
    disableX: {
      type: Boolean,
      default: false,
    },
    adaptive: {
      type: Boolean,
      default: false,
    },
  },
})
